
// Global handler for Product Card clicks
window.fireCardPixel = function(element) {
  if (!element) return;

  var jsonString = element.getAttribute('data-pixel-json');
  if (!jsonString) return;

  try {
    var pixelData = JSON.parse(jsonString);

    // -----------------------------------------------------------
    // FIX: Inject the active browser URL here
    // This guarantees we get the page the user is actually looking at
    // -----------------------------------------------------------

    pixelData.data.parent_page = window.location.pathname;

    pixelData.data.storefront_context =
      document.documentElement.getAttribute('data-storefront-context');

    // 1. Fire Shopify Custom Pixel
    if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
      window.Shopify.analytics.publish("custom_product_card_click", pixelData.data);
    }

  } catch (err) {
    console.warn('Error parsing product card pixel data:', err);
  }
};
